import { FC } from 'react'
import useTariffEnrollmentTabs from '@hooks/useTariffEnrollmentTabs'
import ListPage from '@templates/ListPage'
import Item from './Item'

const CompanyGroupsCuratorTariff: FC = () => {
  const titleTabs = useTariffEnrollmentTabs()

  return (
    <ListPage
      ItemComponent={Item}
      titleTabs={[titleTabs[0]]}
      list={[{}]}
      length={1}
    />
  )
}

export default CompanyGroupsCuratorTariff
